import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import fccapi from './fccapi.js'
export default {
  install (Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl(fccapi.baseUrl+'results')
      .configureLogging(LogLevel.Information)
      .build()
 
    let startedPromise = null
    function start () {
        startedPromise = connection.start().catch(err => {
            console.error('Failed to connect with hub', err)
            return new Promise((resolve, reject) => 
            setTimeout(() => start().then(resolve).catch(reject), 5000))
        })
        return startedPromise
    }
    connection.onclose(() => start())
       
    start()

    // use new Vue instance as an event bus
    const resultsHub = new Vue() 
    // every component will use this.$questionHub to access the event bus
    Vue.prototype.$resultsHub = resultsHub
    // Forward server side SignalR events through $questionHub, where components will listen to them
    connection.on('RunUpdated', (run) => {
        resultsHub.$emit('run-updated', { run })
    })
  }
}